module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Reports")]), _vm._v(" "), _c('div', {
    staticClass: "container wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.userReportList), function(report) {
    return _c('tr', {
      key: report.name
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": report.path,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(report.name))])], 1)])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Report")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f38eca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Reports.vue
// module id = 935
// module chunks = 1